import { render, staticRenderFns } from "./ScoreBar.vue?vue&type=template&id=57b310cd&"
import script from "./ScoreBar.vue?vue&type=script&lang=js&"
export * from "./ScoreBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports